import { CategoryManager } from './CategoryManager';
import { TagManager } from './TagManager';
import { FontManager } from './FontManager';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import type { BlogCategory, BlogTag, BlogFont } from '../../../types';

interface SettingsViewProps {
  categories: BlogCategory[];
  tags: BlogTag[];
  fonts: BlogFont[];
  loading: boolean;
  onCreateCategory: (data: {
    name: string;
    description?: string;
    color?: string;
  }) => Promise<void>;
  onUpdateCategory: (
    id: string,
    data: { name?: string; description?: string; color?: string; sortOrder?: number }
  ) => Promise<void>;
  onDeleteCategory: (id: string) => Promise<void>;
  onCreateTag: (name: string) => Promise<void>;
  onDeleteTag: (id: string) => Promise<void>;
  onUploadFont: (file: File, family: string) => Promise<void>;
  onDeleteFont: (id: string) => Promise<void>;
}

export function SettingsView({
  categories,
  tags,
  fonts,
  loading,
  onCreateCategory,
  onUpdateCategory,
  onDeleteCategory,
  onCreateTag,
  onDeleteTag,
  onUploadFont,
  onDeleteFont,
}: SettingsViewProps) {
  if (loading) {
    return (
      <div className="py-8 text-center text-muted-foreground text-sm">
        Carregando configurações...
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Categorias</CardTitle>
        </CardHeader>
        <CardContent>
          <CategoryManager
            categories={categories}
            onCreateCategory={onCreateCategory}
            onUpdateCategory={onUpdateCategory}
            onDeleteCategory={onDeleteCategory}
          />
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Tags</CardTitle>
        </CardHeader>
        <CardContent>
          <TagManager
            tags={tags}
            onCreateTag={onCreateTag}
            onDeleteTag={onDeleteTag}
          />
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Fontes</CardTitle>
        </CardHeader>
        <CardContent>
          <FontManager
            fonts={fonts}
            onUploadFont={onUploadFont}
            onDeleteFont={onDeleteFont}
          />
        </CardContent>
      </Card>
    </div>
  );
}
